module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/VANITY-FAIR_S01.770df3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/VANITY-FAIR_S01.jpg
// module id = yVdX
// module chunks = 0